import styled, { css, keyframes } from 'styled-components';

const pulseGlow = keyframes`
  0%, 100% {
    box-shadow: 0 2px 8px rgba(255, 187, 0, 0.15);
  }
  50% {
    box-shadow: 0 4px 20px rgba(255, 187, 0, 0.4);
  }
`;

export const Card = styled.button<{ $selected: boolean; $isLifetime: boolean }>(
  ({ theme, $selected, $isLifetime }) => css`
    background: #fff;
    border: 2px solid ${theme.co.secondary95};
    border-radius: ${theme.sz.s4};
    padding: ${theme.sz.s6} ${theme.sz.s7};
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: ${theme.sz.s3} ${theme.sz.s5};
    margin-bottom: ${theme.sz.s5};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    position: relative;
    transition:
      border-color 150ms ease,
      box-shadow 150ms ease;
    width: 100%;
    text-align: left;

    &:hover {
      border-color: ${theme.co.primary50};
    }

    ${
      $selected &&
      css`
        border: 3px solid ${theme.co.primary20};
        background: ${theme.co.primary98};
        box-shadow: 0 2px 8px rgba(255, 187, 0, 0.15);

        &:hover {
          border-color: ${theme.co.primary20};
        }
      `
    }

    ${
      $selected &&
      $isLifetime &&
      css`
        animation: ${pulseGlow} 2s ease-in-out infinite;
      `
    }

    @media (max-height: 900px) {
      padding: ${theme.sz.s4} ${theme.sz.s6};
      margin-bottom: ${theme.sz.s3};
    }

    @media (max-height: 750px) {
      padding: ${theme.sz.s3} ${theme.sz.s5};
      margin-bottom: ${theme.sz.s2};
    }

    @media (max-width: ${theme.sz.lg}) {
      border: 2px solid ${theme.co.secondary95};
      border-radius: 14px;
      padding: ${theme.sz.s4} ${theme.sz.s5};
      gap: ${theme.sz.s2} ${theme.sz.s3};

      ${
        $selected &&
        css`
          border: 3px solid ${theme.co.primary20};
          background: ${theme.co.primary98};
        `
      }

      ${
        $selected &&
        $isLifetime &&
        css`
          animation: ${pulseGlow} 2s ease-in-out infinite;
        `
      }
    }
  `,
);

export const PlanName = styled.p(
  ({ theme }) => css`
    font-weight: 800;
    font-size: 1.5rem;
    line-height: 1.2;
    color: ${theme.co.secondary20};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: ${theme.sz.lg}) {
      font-size: 1.25rem;
    }
  `,
);

export const PlanSub = styled.div(
  ({ theme }) => css`
    font-size: 1.0625rem;
    color: ${theme.co.secondary40};
    font-weight: 500;
    margin-top: 6px;

    @media (max-width: ${theme.sz.lg}) {
      font-size: 0.875rem;
      margin-top: 2px;
    }
  `,
);

export const PriceCol = styled.div(
  () => css`
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `,
);

export const OldPrice = styled.div(
  ({ theme }) => css`
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1;
    color: ${theme.co.secondary60};
    text-decoration: line-through;
    text-align: right;
    margin-bottom: 4px;

    @media (max-width: ${theme.sz.lg}) {
      font-size: 1rem;
    }
  `,
);

export const PlanPrice = styled.div(
  ({ theme }) => css`
    font-weight: 800;
    font-size: 2.5rem;
    line-height: 1;
    color: ${theme.co.secondary20};
    text-align: right;
    letter-spacing: -0.01em;

    @media (max-width: ${theme.sz.lg}) {
      font-size: 1.75rem;
    }
  `,
);

export const BadgeBest = styled.span(
  ({ theme }) => css`
    display: inline-block;
    background: ${theme.co.primary20};
    color: ${theme.co.secondary0};
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    padding: 5px 10px;
    border-radius: 4px;
    text-transform: uppercase;

    @media (max-width: ${theme.sz.lg}) {
      position: absolute;
      top: -10px;
      right: 14px;
      font-size: 0.6875rem;
      letter-spacing: 0.1em;
    }
  `,
);

export const BadgeSave = styled.span(
  ({ theme }) => css`
    display: inline-block;
    background: ${theme.co.success50};
    color: #fff;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    padding: 5px 10px;
    border-radius: 4px;
    text-transform: uppercase;

    @media (max-width: ${theme.sz.lg}) {
      padding: 3px 7px;
    }
  `,
);

export const PriceSub = styled.div(
  ({ theme }) => css`
    font-size: 0.9375rem;
    color: ${theme.co.secondary40};
    font-weight: 500;
    text-align: right;
    margin-top: 4px;

    @media (max-width: ${theme.sz.lg}) {
      font-size: 0.8125rem;
      margin-top: 2px;
    }
  `,
);
